import { Badge, Table, TableCell, TableRow } from '@fukuri-admins/ui/common';
import styles from './styles.module.scss';

type UserUsage = {
  /** 名前。削除済みユーザーは BE 側で「削除済みユーザー」として返す */
  name: string;
  /** 閲覧状況 */
  readStatus: 'read' | 'unread';
  /** 閲覧日時。未読の場合は「-」 */
  readAt: string;
};

type Props = {
  userUsages: UserUsage[];
};

/**
 * 閲覧状況テーブル
 * 閲覧状況・名前・閲覧日時の3列を表示する。未読・既読タブ共通で使用する
 */
export const UsageTable: React.FC<Props> = ({ userUsages }) => (
  <Table
    headers={[
      { label: '閲覧状況', className: styles.statusCol },
      { label: '名前' },
      { label: '閲覧日時', className: styles.readAtCol },
    ]}
  >
    {userUsages.map((row, index) => (
      <TableRow key={index}>
        <TableCell>
          <Badge
            size='sm'
            variant='subtle'
            status={row.readStatus === 'read' ? 'success' : 'neutral'}
            label={row.readStatus === 'read' ? '既読' : '未読'}
          />
        </TableCell>
        <TableCell>{row.name}</TableCell>
        <TableCell>{row.readAt}</TableCell>
      </TableRow>
    ))}
  </Table>
);
